import { IconDefinition } from '@ant-design/icons-angular';
import {
  ReloadOutline,
  SunOutline,
  MoonOutline,
  LogoutOutline,
  SmileOutline,
  PlusOutline,
  TagOutline,
  CloseOutline,
  SaveOutline,
  MinusCircleOutline,
  UnorderedListOutline,
  MailOutline,
  HeatMapOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  UserOutline,
  SendOutline,
  MoreOutline,
  BarChartOutline,
  AppstoreOutline,
  InboxOutline,
  EditOutline,
  UploadOutline,
  DownloadOutline,
  LoadingOutline,
  StopOutline,
  UndoOutline,
  SearchOutline,
  ExperimentOutline,
} from '@ant-design/icons-angular/icons';

export const ICONS: IconDefinition[] = [
  ReloadOutline,
  SunOutline,
  MoonOutline,
  LogoutOutline,
  SmileOutline,
  PlusOutline,
  TagOutline,
  CloseOutline,
  SaveOutline,
  MinusCircleOutline,
  UnorderedListOutline,
  MailOutline,
  HeatMapOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  UserOutline,
  SendOutline,
  MoreOutline,
  BarChartOutline,
  AppstoreOutline,
  InboxOutline,
  EditOutline,
  UploadOutline,
  DownloadOutline,
  LoadingOutline,
  StopOutline,
  UndoOutline,
  SearchOutline,
  ExperimentOutline,
];
